import React from 'react';
import IconName from "../../../svgLogo/SvgLogo";

const UploadFiles = () => {
    return (
        <div className="upload-files-wrapper xmt-20">
            <h2 className="upload-files-title">بارگذاری مدارک</h2>
            <div className="row align-items-center">
                <div className="col-md-6 xmt-6">
                    <div className="upload-text">
                        <h4 className="text-title">تصویر گواهی ارزش افزوده</h4>
                        <p className="text">فروشنده عزیز، لطفا پس از وارد کردن شماره ملی در بخش «بررسی ثبت نام مؤدیان
                            مالیات» در سامانه الکترونیک مالیات بر ارزش افزوده ، از آن صفحه اسکرین شات گرفته و در محل
                            گواهی
                            ارزش افزوده، تصویر آن صفحه را بارگذاری کنید.</p>
                    </div>
                </div>
                <div className="col-md xmt-3 xmt-md-6">
                    <div className="input-upload">
                        <label htmlFor="upload-file--1" className="upload-file-label position-relative">
                            <IconName name="upload_file" className="icon"/>
                            <span className="text-box">بارگذاری فایل</span>
                            <img className="image-uploaded position-absolute value-added-image"/>
                        </label>
                        <input type="file" name="photo" accept="image/*" className="input-upload-file"
                               id="upload-file--1"/>
                    </div>
                </div>
                <div className="col-md-6 xmt-14 xmt-md-25">
                    <div className="upload-text">
                        <div className="upload-text">
                            <h4 className="text-title">تصویر کارت ملی</h4>
                            <p className="text">تصاویر باید صاف و کاملاً واضح باشد.
                                تصویرر و پشت کارت ملی باید به طور جداگانه بارگذاری شود.
                                تصویر کارت ملی همه صاحبان حق امضا در قالب ک عکس در کنار هم قرار گرفته و بارگذاری شود</p>
                        </div>
                    </div>
                </div>
                <div className="col-md-6 xmt-3 xmt-md-25">
                    <div className="input-upload cart-upload">
                        <label htmlFor="upload-file--2" className="upload-file-label position-relative">
                            <IconName name="upload_file" className="icon"/>
                            <span className="text-box">بارگذاری تصویر روی کارت ملی</span>
                            <img className="image-uploaded position-absolute value-added-image"/>
                        </label>
                        <input type="file" accept="image/*" name="photo" className="input-upload-file"
                               id="upload-file--2"/>
                    </div>
                    <div className="input-upload cart-upload xmt-5">
                        <label htmlFor="upload-file--3" className="upload-file-label position-relative">
                            <IconName name="upload_file" className="icon"/>
                            <span className="text-box">بارگذاری تصویر پشت کارت ملی</span>
                            <img className="image-uploaded position-absolute value-added-image"/>
                        </label>
                        <input type="file" accept="image/*" name="photo" className="input-upload-file"
                               id="upload-file--3"/>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default UploadFiles;
